<template>
    <v-card>
        <v-data-table
            :footer-props="{itemsPerPageOptions:[1,5,10]}"
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="total"
            :loading="loading"
            class="elevation-0 dataTable pt-3"
        >
            <template
                v-slot:body.prepend="{ headers }"
            >
                <tr>
                    <td>
                        <v-text-field
                            v-model="pointOfSaleId"
                            label="Código..."
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()">
                        </v-text-field>
                    </td>
                    <td>
                        <v-text-field
                            v-model="pointOfSaleName"
                            label="Nome..."
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()">
                        </v-text-field>
                    </td>
                    <td>
                        <v-text-field
                            v-model="pointOfSaleNote"
                            label="Observações..."
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()">
                        </v-text-field>
                    </td>
                    <td>
                        <v-text-field
                            v-model="roomQuantity"
                            label="Qtd de Quartos..."
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()">
                        </v-text-field>
                    </td>
                    <td>
                        <v-text-field
                            v-model="hotelQuantity"
                            label="Qtd de Hotéis..."
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()">
                        </v-text-field>
                    </td>
                    <td>
                        <v-select
                            class="mt-4"
                            v-model="pointOfSaleActive"
                            chips
                            :menu-props="{ offsetY: true }"
                            :items="selects"
                            item-text="text"
                            item-value="value"
                            label="Status"
                        ></v-select>
                    </td>
                    <td class="text-center" >
                        <v-btn
                            class="mt-4"
                            depressed
                            color="primary"
                            width="80%"
                            v-on:click="getData()"
                        >
                            Buscar
                        </v-btn>
                        <v-btn
                            class="mt-4 mb-4"
                            depressed
                            color="#FBC02D"
                            width="80%"
                            v-on:click="getCleanFilter()"
                        >
                            Limpar
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:item.active="{ item }">
                <v-chip v-if="item.active === 1"
                        class="ma-2"
                        color="green"
                        text-color="white"
                >
                    {{ getActive(item) }}
                </v-chip>
                <v-chip v-if="item.active === 0 "
                        class="ma-2"
                        color="red"
                        text-color="white"
                >
                    {{ getActive(item) }}
                </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-container class="pa-0 ma-0 text-center">
                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <v-icon
                                v-on="on"
                                small
                                class="mr-2 edit"
                                @click="openPointOfSaleFormModal(item)"
                            >
                                mdi-pencil
                            </v-icon>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <v-icon
                                v-if="item.agreement_image"
                                v-on="on"
                                small
                                class="mr-2 edit"
                                @click="openAgreementImageModal(item)"
                            >
                                mdi-eye
                            </v-icon>
                            <v-icon
                                v-else
                                small
                                class="mr-2"
                            >
                                mdi-eye-outline
                            </v-icon>
                        </template>
                        <span>Ver print do acordo</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <router-link :to="{name: 'relatedFaresList', params: {id: item.id}}">
                                <v-icon
                                    v-on="on"
                                    small
                                    class="mr-2 edit"
                                >
                                    mdi-currency-usd
                                </v-icon>
                            </router-link>
                        </template>
                        <span>Ver tarifas do acordo</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <v-icon
                                v-on="on"
                                small
                                class="delete"
                                @click="openDeleteSalePointModal(item)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                        <span>Deletar</span>
                    </v-tooltip>
                </v-container>
            </template>
        </v-data-table>
        <v-dialog v-model="imageDialog" width="auto" overlay-color="#FFF">
            <v-card>
                <v-card-text class="ma-0 pa-0">
                    <v-img
                        :width="550"
                        contain
                        aspect-ratio="1"
                        :src="agreementImagePath"
                    >
                    </v-img>
                </v-card-text>
            </v-card>
        </v-dialog>
        <confirm-deletion-modal
            :dialog-active="deleteDialog"
            :dialog-loading="deleteDialogLoading"
            :entity-to-delete="salePointToDelete.name"
            @delete-method="deleteSalePoint(salePointToDelete.id)"
            @close-dialog="closeDeleteDialog"
        />
    </v-card>
</template>

<script>
import ConfirmDeletionModal from "../Modals/ConfirmDeletionModal";

export default {
    name: "ListPointOfSale",

    components: {
        ConfirmDeletionModal,
    },

    data: () => ({
        items: [],
        loading: '',
        options: {
            sortDesc: [true],
        },
        total: 0,
        pointOfSaleId: '',
        pointOfSaleName: '',
        pointOfSaleNote: '',
        pointOfSaleActive: '',
        roomQuantity: '',
        hotelQuantity: '',
        deleteDialog: '',
        deleteDialogLoading: '',
        formDrawer: false,
        pointOfSaleToUpdate: {},
        imageDialog: '',
        agreementImagePath: '',
        salePointToDelete: {},
        selects: [
            {text: 'Ativo', value: '1'},
            {text: 'Inativo', value: '0'},
        ],
        headers: [
            {text: 'Código', value: 'id', width: '10%'},
            {text: 'Nome', value: 'name'},
            {text: 'Observações', value: 'note', sortable: false},
            {text: 'Qtd de quartos no Acordo', value: 'roomQuantity', width: '10%'},
            {text: 'Qtd de Hotéis no Acordo', value: 'hotelQuantity', width: '10%'},
            {text: 'Status', value: 'active', width: '15%', sortable: false},
            {text: 'Ações', value: 'actions', width: '15%', sortable: false},
        ],
    }),

    methods: {
        getData() {
            this.loading = true;
            const {sortBy, sortDesc, page, itemsPerPage} = this.options;
            const query = `sort=${sortBy}&sortDesc=${sortDesc}&page=${page}&perPage=${itemsPerPage}
                &id=${this.pointOfSaleId}&name=${this.pointOfSaleName}&note=${this.pointOfSaleNote}&active=${this.pointOfSaleActive}
                &roomQuantity=${this.roomQuantity}&hotelQuantity=${this.hotelQuantity}`;
            this.$router.push({
                query: {
                    sort: sortBy,
                    sortDesc: sortDesc,
                    page: page,
                    perPage: itemsPerPage,
                    id: this.pointOfSaleId,
                    name: this.pointOfSaleName,
                    note: this.pointOfSaleNote,
                    active: this.pointOfSaleActive,
                    roomQuantity: this.roomQuantity,
                    hotelQuantity: this.hotelQuantity,
                }
            });

            axios.get(`/api/point-of-sale?${query}`)
                .then(res => {
                    this.items = res.data.data;
                    this.total = res.data.total;
                    this.loading = false;
                });
        },

        openDeleteSalePointModal(item) {
            this.salePointToDelete = item;
            this.deleteDialog = true;
            this.deleteDialogLoading = false;
        },

        closeDeleteDialog() {
            this.deleteDialog = false;
        },

        openPointOfSaleFormModal(item) {
            this.$emit('edit-point-of-sale', item);
        },

        getActive(item) {
            if (item.active === 1) {
                return 'Ativo';
            }
            return 'Inativo';
        },

        deleteSalePoint(id) {
            this.deleteDialogLoading = true;
            axios.delete(`/api/point-of-sale/${id}`)
                .then(res => {
                    window.location.reload();
                    this.$forceUpdate();
                });
        },

        getCleanFilter() {
            this.$router.replace({'query': null});
            window.location.reload();
        },

        openAgreementImageModal(item) {
            this.imageDialog = !this.imageDialog;
            this.agreementImagePath = '/storage/pointsOfSale' + item.agreement_image;
        }
    },

    mounted() {
        if(Object.keys(this.$route.query).length) {
            const {
                sort,
                sortDesc,
                page,
                perPage,
                pointOfSaleId,
                pointOfSaleName,
                pointOfSaleNote,
                pointOfSaleActive,
                roomQuantity,
                hotelQuantity,
            } = this.$route.query;
            if (sort) {
                this.options.sortBy = sort;
            }
            if (sortDesc) {
                this.options.sortDesc = sortDesc;
            }
            if (page) {
                this.options.page = parseInt(page ? page : 1);
            }
            if (perPage) {
                this.options.perPage = perPage;
            }
            if (pointOfSaleId) {
                this.pointOfSaleId = pointOfSaleId;
            }
            if (pointOfSaleName) {
                this.pointOfSaleName = pointOfSaleName;
            }
            if (pointOfSaleNote) {
                this.pointOfSaleNote = pointOfSaleNote;
            }
            if (pointOfSaleActive) {
                this.pointOfSaleActive = pointOfSaleActive;
            }
            if (roomQuantity) {
                this.roomQuantity = roomQuantity;
            }
            if (hotelQuantity) {
                this.hotelQuantity = hotelQuantity;
            }
        }
    },

    watch: {
        options: {
            handler() {
                this.getData()
            },
            deep: true,
        },
    }
}
</script>

<style scoped>
.agreement-image {
    height: auto;
}
</style>
